export default {
      id: "ic-plan-antilles-usage",
      viewBox: "0 0 40 40",
      url: "../../../plugins/creasit-builder/assets/dist/images/" + "sprite.svg#ic-plan-antilles-usage",
      toString: function () {
        return this.url;
      }
    }